import { Guid, IBaseModel } from '@/interfaces/base'
import emptyId from '@/statics/empty-id'
import { i18nInstance } from '@/plugins/localization'

export class Function implements IBaseModel {

	id: Guid = emptyId
	name!: string
	maxArg!: number
	minArg!: number

}

export class ConvFunction extends Function {
	pName!: string
	argument!: string

	constructor(init?: Partial<ConvFunction>) {
		super()
		Object.assign(this, init)
		// @ts-ignore
		if (this.name) this.pName = i18nInstance.global.t(`salary.item.function-names.${this.name}`)
		if (this.maxArg && this.minArg) this.argument = i18nInstance.global.t('salary.item.function-argument', { maxArg: this.maxArg, minArg: this.minArg })
	}

}